import React from 'react'

import useLocation from 'hooks/useLocation'
import { ErrorCard } from 'ui'

import { Container } from './styles'


class ErrorBoundery extends React.Component {
  constructor (props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError (error) {
    // Actualiza el estado para renderizar la interfaz de usuario de error en lugar del árbol de componentes que falló
    return { error }
  }

  componentDidCatch (error, info) {}

  render () {
    if (this.state.error) {
      return (
        <Container $isCreators={this.props.isCreators}>
          <ErrorCard
            isBackHome
            stack={this.state.error.stack}
          />
        </Container>
      )
    } else {
      return this.props.children
    }
  }
}

const ErrorBounderyWrapper = ({ children }) => {
  const { isCreators } = useLocation()

  return (
    <ErrorBoundery isCreators={isCreators}>
      {children}
    </ErrorBoundery>
  )
}

export default ErrorBounderyWrapper
